<template>
  <div>
    <basic-container>
      <div class="page-container partner-manage-page">

        <!-- 搜索 -->
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <el-input clearable v-model="form.account" placeholder="账号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.messageType" size="small" clearable placeholder="推送类型">
                <el-option label="快速屏保" :value="1"></el-option>
                <el-option label="视频" :value="2"></el-option>
                <el-option label="图片" :value="3"></el-option>
                <el-option label="通知" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
            <el-date-picker v-model="searchTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作 -->

        <!-- 列表 -->
        <el-table 
          :cell-style="{'text-align':'center'}"
          :header-cell-style="{'text-align':'center'}"
          :max-height="tableHeight"
          v-loading="listLoading"
          element-loading-text="加载中"
          style="width: 100%"
          border
          :data="tableDataList"
          @selection-change="handleSelectionChange">
          <el-table-column 
            type="selection">
          </el-table-column>
          <el-table-column 
            prop="userAccount"
            fixed
            label="账号"
            align="center"
            header-align="center">
          </el-table-column>
          <el-table-column 
            prop="messageType"
            align="center"
            header-align="center"
            :formatter = "formatter"
            label="推送类型">
          </el-table-column>
          <el-table-column 
            prop="content"  
            align="center"
            header-align="center"
            label="推送内容">
            <template slot-scope="scope">         
              <div v-if="scope.row.messageType == 1">
                <el-col :span="24">
                  {{scope.row.content}}
                </el-col>
              </div>
              <div v-if="scope.row.messageType == 2" class="video_box">
                <el-col :span="24">
                  <div v-for="(item, index) in scope.row.content.split(',')" :key="index" @click="platVideo(item)" class="videoitem">{{item}}</div>
                </el-col>
              </div>
              <ul class="push_imgbox" v-if="scope.row.messageType == 3">
                <li v-for="(item, index) in  scope.row.content.split(',')" :key="index" @click="showPreviewImg(item)"><img :src="item" height="30px"  /></li>
              </ul>
              <el-col v-if="scope.row.messageType == 4">{{scope.row.content}}</el-col>
            </template>
          </el-table-column>
          <el-table-column 
            prop="dongleId"
            align="center"
            header-align="center"
            label="所推送设备">
            <template slot-scope="scope">
              <el-button 
                @click="viewAccount(scope.row)"
                size="small"
                type="text">
                点击查看设备{{[scope.row.dongleId.split(',').length]}}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column 
            prop="createTime"
            align="center"
            header-align="center"
            label="推送时间">
          </el-table-column>
          <el-table-column 
            fixed="right"
            width="200"
            label="操作">
            <template slot-scope="scope">
              <el-button 
                v-auth="'enterprisePush_view'"
                @click="openDialog(scope.row, true)"
                size="small"
                type="text">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="table-pagination">
          <TablePagination 
          :page-size.sync="pageConfig.size"
          :total="total"
          :current-page.sync="pageConfig.current"
          @change="handlePageChange" />
        </div>
      </div>

      <!-- 表单 -->
      <el-dialog 
        :title="dialogType"
        :visible.sync="showDialog"
        append-to-body
        width="40%"
        :before-close="handleAddOrEditClose"
        top="36vh">
        <el-row>
          <el-col :span="4">
            <div>账号</div>
          </el-col>
          <el-col :span="20">
            <div>{{checkItem.userAccount}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div>类型</div>
          </el-col>
          <el-col :span="20">
            <div>{{formateMessageType}}</div>
          </el-col>
        </el-row>
        <!-- 屏保 -->
        <div class="screenImg" v-if="checkItem.messageType == 1">
          <el-row>
            <el-col :span="4">
              <div>屏保内容</div>
            </el-col>
            <el-col :span="20">
              <div>{{checkItem.content}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div>屏保图片</div>
            </el-col>
            <el-col :span="20">
              <img :src="checkItem.extraOne" @click="showPreviewImg(checkItem.extraOne)">
            </el-col>
          </el-row>
        </div>
        <!-- 视频 -->
        <div class="video" v-if="checkItem.messageType == 2">
          <el-row>
            <el-col :span="4">
              <div>视频链接</div>
            </el-col>
            <el-col :span="20">
              <div v-for="(item, index) in checkItem.content.split(',')" :key="index" class="videoitem" @click="platVideo(item)">{{item}}</div>
            </el-col>
          </el-row>
        </div>
        <!-- 图片 -->
        <div class="image" v-if="checkItem.messageType == 3">
          <el-row>
            <el-col :span="4">
              <div>图片链接</div>
            </el-col>
            <el-col :span="20">
              <div v-for="(item, index) in checkItem.content.split(',')" :key="index" class="videoitem" @click="showPreviewImg(item)">
                <img :src="item">
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 通知 -->
        <div class="notice" v-if="checkItem.messageType == 4">
          <el-row>
            <el-col :span="4">
              <div>通知内容</div>
            </el-col>
            <el-col :span="20">
              <div>{{checkItem.content}}</div>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <!-- 视频预览 -->
      <el-dialog title="视频预览"  append-to-body width="50%"
          :visible.sync="dialogShowPlayVideo" 
          :before-close="handleVideoClose">
        <video :src="playURL" id="vide" controls="controls" width="100%"></video>
      </el-dialog>
      <!-- 图片预览 -->
      <el-dialog title="图片预览"  append-to-body width="50%"
          :visible.sync="dialogShowPreviewImg">
        <!-- <video :src="playURL" id="vide" controls="controls" width="100%"></video> -->
        <img :src="previewImg" width="100%">
      </el-dialog>
    </basic-container>

  </div>
</template>
<script>
import { merge, deepCopy } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
import { getDongletemplatemessage } from "@/api/leboHardwareManage/leboHardwareManage";

export default {
  name: 'enterpriseUser',
  mixins: [ListMixins],
  data () {
    return {
      listLoading: false,
      form: {     //查询的时候需要用到的参数
        account: '',
        messageType: '',
      },
      checkItem: {  // 选中编辑/新增需要得数据
      },
      dialogType: '',
      tableDataList: [], // 列表数据
      pageConfig: {},
      total: 0,
      showDialog: false,
      dialogShowPlayVideo: false,
      playURL: '',
      searchTime: '',
      dialogShowPreviewImg: false,
      previewImg: ''
    }
  },
  computed:{
    // 计算属性转义type
    formateMessageType() {
      switch (this.checkItem.messageType) {
        case 1:
          return '快速屏保'
        case 2:
          return '视频'
        case 3:
          return '图片'
        case 4:
          return '通知'
        default: ''
          break;
      }
    }
  },
  created () {
    this.getList();
  },
  methods: {
    getList () {
      this.listLoading = true
      const query = merge({}, this.form, this.pageConfig)
      query.startTime = this.searchTime ? this.searchTime[0] : ''
      query.endTime = this.searchTime ? this.searchTime[1] : ''
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableDataList = res.data.data.records
          this.pageConfig.size = res.data.data.size
          this.pageConfig.current = res.data.data.current
          this.total = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getDongletemplatemessage(query).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 查看账号详情
    viewAccount(row) {
      console.log(row)
      this.$router.push({
        path: '/leboHardwareManage/enterpriseDevice',
        query: {
          dongleIds: row.dongleId
        }
      });
    },
    // 播放视频
    platVideo(videoUrl) {
      this.playURL = videoUrl
      this.dialogShowPlayVideo = true;
    },
    // 预览图片
    showPreviewImg(imgurl) {
      this.previewImg = imgurl
      this.dialogShowPreviewImg = true
    },
    // 关闭视频弹窗
    handleVideoClose(done) {
      //视频暂停
      console.log("[handleVideoClose] 监听关闭")
      let vide = document.getElementById("vide");
      vide.pause();
      done();
    },
    // 对type转义
    formatter(row) {
      switch (row.messageType) {
        case 1:
          return '快速屏保'
        case 2:
          return '视频'
        case 3:
          return '图片'
        case 4:
          return '通知'
        default: ''
          break;
      }
    },
    // 查看
    openDialog (row, isView) {
      this.dialogType = '查看'
      this.checkItem = deepCopy(row)
      this.showDialog = true
      console.log('[openDialog]', isView)
    },
    //关闭弹窗编辑或者新增
    handleAddOrEditClose () {
      this.showDialog = false
    }
  }
}
</script>
<style lang="scss">
.table-pagination {
  margin-top: 20px;
  text-align: right;
}
.partner-manage-page {
  .cell-content {
    color: #008080;
    cursor: pointer;
    text-decoration: underline;
    display: inline-block;
    padding: 6px 10px;
    line-height: 1.3em;
  }
}
.el-row {
  margin-bottom: 20px;
}
.screenImg {
  img {
    width: 300px;
    height: 200px;
  }
}
.image {
  .videoitem {
    display: inline-block;
    margin-right: 10px;
  }
  img {
    width: 200px;
    height: 100px;
  }
}
.videoitem {
  margin-bottom: 10px;
}
.video_box {
  .el-col {
    color: #409EFF;
    cursor: pointer;
  }
}
.push_imgbox {
  list-style: none !important;
  display: flex;
  padding: 0;
  li {
    float: left;
    margin-right: 5px;
  }
  img {
    display: inline-block;
    height: 30px;
    width: 48px;
  }
}
</style>
